import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Grid, 
  TextField,
  DialogContent, DialogActions
} from '@material-ui/core';
import { 
  EditOutlined as EditOutlinedIcon 
} from '@material-ui/icons';
import Controls from "../../components/controls/Controls";
import Popup from "../../components/Popup";
import { updateOrderAction } from "../../redux/actions/orderActions";
import Notification from '../../components/Notification';
import { Formik } from "formik";
import * as Yup from 'yup';
import { Alert as MuiAlert } from "@material-ui/lab";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";

const Alert = styled(MuiAlert)(spacing);

export default function OrderCommentsDialog({ localStateOrder }) {
  const dispatch = useDispatch();
  const orderDetails = useSelector(state => state.orderReducer.orderDetails);
  const [openPopup, setOpenPopup] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });

  const notification = (message, type) => {
    setNotify({
      isOpen: true,
      message: message,
      type: type
    })
  }

  return (
          <>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={8}>
                <span className="text-gray">Order Comments</span>
                <TextField
                  type="text"
                  name="order_comments"
                  disabled
                  value={orderDetails.eventticketdetailid === localStateOrder.eventticketdetailid ? orderDetails.order_comments : localStateOrder.order_comments}
                  variant="outlined"
                  my={3}
                  fullWidth
                  multiline
                  minRows={5}
                  maxRows={10}
                  InputProps={{
                    style: {
                      fontSize: '14px', fontWeight: 700, color: 'black'
                    }
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <Controls.ActionButton 
                  className="outlined-primary"
                  onClick={() => setOpenPopup(true)}>
                    <EditOutlinedIcon fontSize="small" variant="outlined" color="primary" />
                </Controls.ActionButton>
              </Grid>
            </Grid>

              <Popup
                title="Edit Comments"
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
              >
                <Formik initialValues={{ order_comments: orderDetails.order_comments }}
                    validationSchema={Yup.object().shape({ order_comments: Yup.string() })}
                    onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                      try {
                        const updateObj = {
                          order_comments: values.order_comments
                        }
                        await dispatch(updateOrderAction(orderDetails.eventticketdetailid, updateObj));
                        setOpenPopup(false);
                        notification("Comments updated!", "success");
                        setStatus({ success: true });
                        setSubmitting(false);
                      } catch (error) {
                        const message = error.response?.data?.message || error.response?.data || error.message || "Something went wrong";
                        setStatus({ success: false });
                        setErrors({ submit: message });
                        setSubmitting(false);
                      }
                    }}
                  >
                    {({
                      errors,
                      handleBlur,
                      handleChange,
                      handleSubmit,
                      isSubmitting,
                      touched,
                      values,
                      status,
                    }) => (
                      <form noValidate onSubmit={handleSubmit}>
                        {errors.submit && (
                          <Alert mt={2} mb={1} severity="warning">
                            {errors.submit}
                          </Alert>
                        )}
                        <DialogContent style={{ width: 400, paddingRight: 0, paddingLeft: 0 }}>
                          <TextField
                            type="text"
                            name="order_comments"
                            label="Order Comments"
                            value={values.order_comments}
                            variant="outlined"
                            error={Boolean(touched.order_comments && errors.order_comments)}
                            fullWidth
                            helperText={touched.order_comments && errors.order_comments}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            my={3}
                            multiline
                            minRows={5}
                            maxRows={10}
                          />
                        </DialogContent>
                        <DialogActions>
                          <Controls.Button 
                            text="Cancel" className="link-gray" 
                            onClick={() => setOpenPopup(false)}>
                          </Controls.Button>
                          <Controls.Button
                            my={3}
                            type="submit"
                            text="Save" 
                            className="link-red"
                            disabled={isSubmitting}>
                          </Controls.Button>
                        </DialogActions>
                      </form>
                    )}
                </Formik>
              </Popup>

              <Notification notify={notify} setNotify={setNotify} />
          </>
  )
}
